import React from 'react';
import { formatDayDate } from '../../utils/date';
import { FEW_SLOTS_THRESHOLD } from '../../utils/constants';

const availabilityLabel = (n) => {
  if (n <= FEW_SLOTS_THRESHOLD) return `${n} slot${n === 1 ? '' : 's'} left`;
  return 'Many slots';
};

/** "Earliest available" quick picks above the calendar. */
export default function EarliestDates({ items, loading, selected, onSelect }) {
  if (loading) {
    return (
      <div className="earliest">
        {[0, 1, 2].map((i) => <div key={i} className="skeleton earliest__item" style={{ height: 64 }} />)}
      </div>
    );
  }
  if (!items.length) return <p className="u-muted">No open slots in the next few months.</p>;
  return (
    <div className="earliest">
      {items.map((it) => (
        <button
          key={it.date}
          type="button"
          className={`earliest__item ${selected === it.date ? 'earliest__item--active' : ''}`}
          onClick={() => onSelect(it.date)}
        >
          <span className="earliest__date">{formatDayDate(it.date)}</span>
          <span className="earliest__sub">{availabilityLabel(it.slotsOpen)}</span>
        </button>
      ))}
    </div>
  );
}
